export const category10 = [
  'rgb(31, 119, 180)',
  'rgb(255, 127, 14)',
  'rgb(44, 160, 44)',
  'rgb(214, 39, 40)',
  'rgb(148, 103, 189)',
  'rgb(140, 86, 75)',
  'rgb(227, 119, 194)',
  'rgb(127, 127, 127)',
  'rgb(188, 189, 34)',
  'rgb(23, 190, 207)',
];

export const byZone = category10; // legacy

export const nivo = [
  'rgb(232, 193, 160)',
  'rgb(244, 117, 96)',
  'rgb(241, 225, 91)',
  'rgb(232, 168, 56)',
  'rgb(97, 205, 187)',
  'rgb(151, 227, 213)',
];

export default {
  category10,
  nivo,
};
